import React from 'react'

export default function AboutStatement() {
  return (
    <>
    <section className="aboutpage-state bodygap">
        <div className="row align-items-center">
            <div className="col-lg-5 col-sm-7 col-md-4">
                <img src="/image/about-state-1.webp" className="img-responsive aboutstate-img1" alt="about" loading="lazy"/>
            </div>

            <div className="col-lg-3 col-sm-5 col-md-3">
                <img src="/image/about-state-2.webp" className="img-responsive aboutstate-img2" alt="about" loading="lazy"/>
            </div>

            <div className="col-lg-4 col-sm-12 col-md-5">
                <div className="aboutstate-text wow animate__animated animate__slideInRight" data-wow-duration="1.2s" data-wow-delay="0.1s">
                    <h3 className="heading">The Statement</h3>
                    <p>At Sonam Label, our vision is simple yet profound - to create pieces that honour the emotions behind a bride’s most cherished moments. Every design begins with intention, shaped by the stories families share and the meaning they hope their ensembles will carry. For us, clothing is not decoration; it is a vessel of identity, memory, and promise. Our purpose is to craft timeless pieces that make brides feel understood, mothers feel reassured, and every moment feel beautifully unforgettable.</p>
                </div>
            </div>

        </div>
    </section>
    </>
  )
}
